import { styled } from '@mui/material/styles'
import { Box, Dialog, dialogClasses } from '@mui/material'
import Grid from '@mui/material/Grid2'

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`.${dialogClasses.paper}`]: {
    height: '600px',
    overflow: 'hidden',
    borderRadius: 0,
    margin: 0,
    [theme.breakpoints.down('md')]: {
      height: '90vh',
      width: '90vw',
      '@supports (height: 1dvh)': {
        height: '90dvh',
      },
    },
  },
  [`.${dialogClasses.paperScrollPaper}`]: {
    [theme.breakpoints.down('md')]: {
      maxHeight: '90vh',
      '@supports (height: 1dvh)': {
        maxHeight: '90dvh',
      },
    },
  },
}))

export const GuestImageWrapper = styled(Box)`
  position: relative;
  overflow: hidden;
  width: 300px;
  ${({ theme }) => theme.breakpoints.down(800)} {
    width: 100px;
  }
`

export const ContentGrid = styled(Grid)`
  height: 100%;
  flex-wrap: nowrap;
  overflow-y: auto;
  position: relative;

  ${({ theme }) => theme.breakpoints.down('md')} {
    overflow-y: hidden;
  }
`

export const ContentGridItem = styled(Grid)`
  position: relative;
  flex: 3;
  padding: 15px 35px 30px;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;

  ${({ theme }) => theme.breakpoints.down('md')} {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 10px 15px 15px;
  }
`

export const LogoWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
`
